import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

import './Works.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { EffectCards, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';





import AddBarangay from '../../Assets/SwiperAssets/AddBarangay.png';
import AddBox from '../../Assets/SwiperAssets/AddBox.png';
import BackandRestore from '../../Assets/SwiperAssets/BackandRestore.png';
import Barangay from '../../Assets/SwiperAssets/Barangay.png';
import DeleteBarangay from '../../Assets/SwiperAssets/DeleteBarangay.png';
import DeleteBox from '../../Assets/SwiperAssets/DeleteBox.png';
import Direction from '../../Assets/SwiperAssets/Direction.png';
import HomePanel from '../../Assets/SwiperAssets/HomePanel.png';
import Login from '../../Assets/SwiperAssets/Login.png';
import LoginPassword from '../../Assets/SwiperAssets/LoginPassword.png';
import Map from '../../Assets/SwiperAssets/Map.png';
import Map2 from '../../Assets/SwiperAssets/Map2.png';
import Ports from '../../Assets/SwiperAssets/Ports.png';
import UpdateBarangay from '../../Assets/SwiperAssets/UpdateBarangay.png';
import UpdateBox from '../../Assets/SwiperAssets/UpdateBox.png';
import UpdateUser from '../../Assets/SwiperAssets/UpdateUser.png';


const Works = () => {

  useEffect(() => {
    AOS.init();
  }, [])



  return (
    <section id="works">
      <div className="worksIntro">
      <h1 
           data-aos="fade-up"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">My Project</h1>
      <p 
           data-aos="fade-up"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">NAPs Management System, a system developed by myself during my OJT in DCTECH Microservice Incorporated using VB.net and MySQL to manage data connected to Network Access Points (NAPs) mounted on electrical poles.</p>
      </div>
        <div className="worksMainContainer">
           <div className="worksContainer">
              <div className="cardSwiper"
           data-aos="fade-up"
           data-aos-offset="-400"
           data-aos-delay="400"
           data-aos-duration="1000"
           data-aos-easing="ease"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
              <Swiper 
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards, Navigation, Pagination]}
                className="mySwiper"
                pagination={{ clickable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
                >
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={Login} alt="Login" />
                            <div className='cardText'>
                               <h3>Login Page</h3>
                               <p>In this part, the user will login with their username and password. The default login credentials are admin in both username and password.</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={HomePanel} alt="HomePanel" />
                          <div className='cardText'>
                               <h3>Home Panel</h3>
                               <p>In this panel, the user will see a list of all NAPs based on the barangay selected, and will be able to add, change, remove, and see a list of clients who had connections with a certain NAP. If the receive Direction checkbox is selected, the user can view the location of the NAP using Google Maps in the default browser and receive directions from the NAP to the client.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={Map} alt="Map" />
                          <div className='cardText'>
                               <h3>NAP Location Tracker</h3>
                               <p>In this part, the user can click the 'View Map' button (see previews card) and view the location of the NAP(Network Access Point).</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={Direction} alt="Direction" />
                          <div className='cardText'>
                               <h3>NAP and Client Locator</h3>
                               <p>The user will input the map coordinates of the client to see the distance and direction between the NAP and client.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={Map2} alt="Map2"/>
                          <div className='cardText'>
                               <h3>Direction in Google Map</h3>
                               <p>This is the result after the input of client map coordinates, which displays the direction and distance between the client and NAP.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={Ports} alt="Ports" />
                          <div className='cardText'>
                               <h3>Ports</h3>
                               <p>In this part, the user can view the details of NAP as well as a list of customers that are connected to a port, as well as the position and direction with distance between NAP and clients in this section.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={AddBox} alt="AddBox" />
                          <div className='cardText'>
                               <h3>Add New NAP</h3>
                               <p>In this part, the user can add a new NAP with map coordinates, box number (Auto Increment), available slot, description, and street.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={UpdateBox} alt="UpdateBox" />
                          <div className='cardText'>
                               <h3>Update NAP</h3>
                               <p>In this part, the user can update the NAP details like map coordinates, available slot, description, and street, but not the box number.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={DeleteBox} alt="DeleteBox" />
                          <div className='cardText'>
                               <h3>Delete NAP</h3>
                               <p>The user can delete a NAP but it gives a warning first before proceeding to deletion.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={Barangay} alt="Barangay" />
                          <div className='cardText'>
                               <h3>Location List Panel</h3>
                               <p>In this panel, the user can examine a list of barangays where NAPs are situated as well as add, update, backup, and restore the system's database.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={BackandRestore} alt="BackandRestore" />
                          <div className='cardText'>
                               <h3>Backup and Restore</h3>
                               <p>This is the part where the user can create a database backup and also restore if the data is ever deleted or, more likely, wrong.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={AddBarangay} alt="AddBarangay" />
                          <div className='cardText'>
                               <h3>Add New Barangay</h3>
                               <p>In this part, the user can add a new Barangay that contains NAP.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={UpdateBarangay} alt="UpdateBarangay" />
                          <div className='cardText'>
                               <h3>Update Barangay</h3>
                               <p>The user can update the barangay name if ever it is not written correctly.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={DeleteBarangay} alt="DeleteBarangay" />
                          <div className='cardText'>
                               <h3>Delete Barangay</h3>
                               <p>The user can delete a specific Barangay but it gives a warning first before proceeding to deletion.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="dctechContainer">
                          <img className='cardsPNG' src={LoginPassword} alt="LoginPassword" />
                          <div className='cardText'>
                               <h3>Login Settings Panel</h3>
                               <p>	The user will alter the login details in this section, however first the user must login before changing the username and password.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                    <div className="dctechContainer">
                          <img className='cardsPNG' src={UpdateUser} alt="UpdateUser" />
                          <div className='cardText'>
                               <h3>Update Username and Password</h3>
                               <p>In this final part, the user can update the login details of the system.</p>
                          </div>
                        </div>
                    </SwiperSlide>
                    </Swiper>
              </div>
           </div>
        </div>

    </section>
  )
}

export default Works
